import { render, staticRenderFns } from "./CourseLoadsForm.vue?vue&type=template&id=319f4192"
import script from "./CourseLoadsForm.vue?vue&type=script&lang=js"
export * from "./CourseLoadsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports